var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cart-page__header" }, [
    _c(
      "span",
      {
        staticClass: "cart-page__header-action",
        on: { click: _vm.updateCart },
      },
      [_vm._v("Очистить корзину")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }